import { Text, Image, IconButton, Icon } from '@lounge-fe/ui-kit'
import { UpsellsItemProps } from './types'
import { Price } from '../Price'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'
import { ProductPagePriceRange } from '../ProductPagePriceRange'

interface CardProps extends UpsellsItemProps {
  onClick?: () => void
}

const Card = ({
  title,
  price,
  compareAtPrice,
  variant_min_price: variantMinPrice,
  variant_max_price: variantMaxPrice,
  image,
  onClick,
}: CardProps) => {
  const { t } = useTranslation()

  const hasVariablePrice =
    variantMinPrice && variantMaxPrice && variantMinPrice !== variantMaxPrice

  return (
    <div onClick={onClick} className="cursor-pointer">
      <div className="mb-2 relative">
        {image && (
          <Image
            alt={title}
            {...image}
            className={twMerge('aspect-square w-full', image.className)}
          />
        )}
        <IconButton
          aria-label={t('product.quick_add')}
          className="z-10 absolute left-1/2 bottom-4 top-auto p-1 h-8 w-8 bg-[#FFFFFFB3] hover:bg-[#FFFFFFB2] backdrop-blur-[1px] transform -translate-x-1/2"
          icon={<Icon.Plus variant="light" className="w-3 h-3" />}
          size="sm"
          variant="ghost"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Text variant="title-six">{title}</Text>
        {hasVariablePrice ? (
          <ProductPagePriceRange
            variant="title-six"
            minPrice={variantMinPrice / 100}
            maxPrice={variantMaxPrice / 100}
          />
        ) : (
          <Price
            variant="title-six"
            price={price / 100}
            compareAtPrice={compareAtPrice && compareAtPrice / 100}
          />
        )}
      </div>
    </div>
  )
}

export { Card }
